class ClientModalController {

    constructor() {
        'ngInject'
    }

    $onInit() {
        this.parentController = this.resolve.parentController;
        this.groupList = this.resolve.groupList;
        this.newClient = this.resolve.newClient;

        // make 'Default' the group selected
        this.setGroup(this.groupList.filter((g) => g.name === 'Default').pop());
    }

    closeModal() {
        this.modalInstance.close();
    }

    setGroup(group) {
        this.selectedGroup = group;
        // there is only one group being assigned, but the endpoint accepts multiple
        this.newClient.groups = [group];
    }
}

export default ClientModalController;


// WEBPACK FOOTER //
// ./app/components/client-admin/client-add-modal/client-add-modal-controller.js